import {React} from 'common'
import {useGetClientsQuery, useI18n} from 'store/Store'
import SearchIcon from '@mui/icons-material/Search'
import {InputAdornment, styled} from '@mui/material'
import tables from 'constants/tables'
import AutocomplateInput from 'components/Control/AutocomplateInput'
import {matchSorter} from 'match-sorter'
import {removeUserPrefixes} from 'services/utils/apiUtils'
import {useDeviceDetect} from 'services/hooks'
import analyticsService from 'services/analytic'
import {useNavigate} from 'react-router-dom'

const SearchArea = () => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()
    const navigate = useNavigate()

    const {data: clients} = useGetClientsQuery()

    const formatClient = (option) => {
        const {
            ClientFirstName,
            ClientLastName,
            ClientPhone,
            ClientId,
            AccountKey,
        } = option
        return `${ClientFirstName} ${ClientLastName} , ${removeUserPrefixes(
            AccountKey
        )(ClientPhone)} , ${removeUserPrefixes(AccountKey)(ClientId)}`
    }

    const filterOptions = (options, {inputValue}) =>
        matchSorter(options, inputValue, {
            keys: tables.clients.searchableKeys,
        })

    return (
        <Container isMobile={isMobile}>
            <AutocomplateInput
                name="search"
                placeholder={`${i18n.t('header.search')}`}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" style={{marginTop: 0}}>
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    disableUnderline: true,
                    style: {height: 46, borderRadius: 13, padding: 0},
                }}
                options={clients}
                getOptionLabel={formatClient}
                filterFunc={filterOptions}
                onOpen={() => analyticsService.navToolPressed('searchbar')}
                onChange={(e, value) => {
                    navigate(`/client/${value.PlannerClientKey}`)
                    analyticsService.navToolPressed('searchbar_results')
                }}
            />
        </Container>
    )
}

export default SearchArea

const Container = styled('div')`
    width: ${({isMobile}) => (isMobile ? 100 : 45)}%;
    margin: auto;
`
